function getIndexesString(text: string, token: string): number[] {
  let pos = 0;
  let i = -1;
  const output: number[] = [];

  while (pos !== -1) {
    pos = text.indexOf(token, i + 1);
    i = pos;

    if (pos !== -1) {
      output.push(pos);
    }
  }

  return output;
}

function splitTextChunker(chunks: string[]): string[] {
  const MIN = 5;
  const SPLIT = 150;
  const MIDPOINT_DIVISOR = 2;
  let output: string[] = [];
  let chunkSaved = '';

  chunks.forEach((chunk) => {
    if (chunkSaved) {
      chunk = chunkSaved + chunk;
      chunkSaved = '';
    }

    const chunkLength = chunk.length;

    if (chunkLength < MIN) {
      chunkSaved = chunk;
    } else if (chunkLength > SPLIT) {
      const positions = getIndexesString(chunk, ',');
      const separated = positions.reverse().some((e) => {
        if (e <= chunkLength / MIDPOINT_DIVISOR) {
          const parts: string[] = [];
          parts.push(chunk.substring(0, e + 1));
          parts.push(chunk.substring(e + 1));
          parts.forEach((part) => {
            if (part.length > SPLIT && part.includes(',')) {
              const split = splitTextChunker([part]);
              output = output.concat(split);
            } else {
              output.push(part);
            }
          });
          return true;
        }

        return false;
      });

      if (!separated) {
        output.push(chunk);
      }
    } else {
      output.push(chunk);
    }
  });

  if (chunkSaved) {
    output.push(chunkSaved);
  }

  return output;
}

export function normalizeForChunking(text: string): string {
  return text
    .replace(/\n{2,}/g, '<br>') // To preserve the \n from titles
    .replace(/\s\s+/g, ' ') // Remove multiple spaces, so highlighting works correctly
    .replace(/\n/g, ' ') // Remove the \n added at the end of the line
    .replace(/<br>/g, ' \n'); // Add back the \n we removed, only to preserve titles
}

export function textChunker(text: string): { text: string; percentage: number }[] {
  const result = normalizeForChunking(text);
  const chunks = result.split('\n'); // To keep pauses from titles
  const chunks2: string[] = chunks.map((chunk) => chunk.split('.')).flat();
  const output = splitTextChunker(chunks2);

  return output
    .filter((o) => {
      o = o.trim();
      return o !== '' && o !== ' ' && o !== '\n' && o !== '\r';
    })
    .map((o, i) => ({
      text: o.trim(),
      percentage: i / output.length,
    }));
}

export interface ChunkRange {
  start: number;
  end: number;
}

export function getChunkRanges(normalizedText: string, chunks: { text: string }[]): ChunkRange[] {
  let cursor = 0;

  return chunks.map(({ text }) => {
    const index = normalizedText.indexOf(text, cursor);
    const start = index === -1 ? cursor : index;
    cursor = start + text.length;
    return { start, end: cursor };
  });
}
